module.exports = __webpack_public_path__ + "static/media/plans-table-ita.11b21f79.png";